import { IRootState } from '../../../store'
import { ICcHpiOptionsState } from '../store/options.types'

export const getCcHpiOptionsSelector = (state: IRootState): ICcHpiOptionsState => state.options.ccHpiOptions
